import Config from "../config/config";
import axios from "axios";

const { baseURL } = Config.API;

const getMails = () => {
  return axios({
    method: 'GET',
    baseURL,
    url: '/mails',
  });
};

const addMail = (email) => {
  return axios({
    method: 'POST',
    baseURL,
    url: '/mails',
    data: {
      email,
    },
  });
};

const updateMail = (id, email) => {
  return axios({
    method: 'PATCH',
    baseURL,
    url: `/mails/${id}`,
    data: {
      email,
    },
  });
};

const deleteMail = (id) => {
  return axios({
    method: 'DELETE',
    baseURL,
    url: `/mails/${id}`,
  });
};

export default {
  getMails,
  addMail,
  updateMail,
  deleteMail,
};
